<template>
  <div
    v-if="confidenceSummary"
    class="insights-widget-confidence-summary w-full"
  >
    <InsightsUnusualActivityMemberDialog
      v-if="showDateDialog"
      show
      :time-zone="timeZone"
      :dialog-date="dialogDate"
      @close="toggleDateDialog"
    />

    <div class="my-10 mx-4">
      <a
        v-track:click="{ label: 'Unusual view more' }"
        href="#"
        @click="toggleConfidenceDialog"
      >
        View details
      </a>
    </div>
    <AppDialog
      v-if="showConfidenceDialog"
      class="insights-confidence-summary-dialog"
      show
      append-to-body
      is-dismissable
      title="Unusual instances"
      position="top"
      size="medium"
      @close="toggleConfidenceDialog"
    >
      <template #header>
        <div class="d-flex align-items-center justify-space-between mt-5 py-5">
          <div>
            <AppAvatar
              size="speck"
              :avatar="currentDashboardUser.avatar"
            />
            <span>{{ currentDashboardUser.name }}</span>
          </div>
        </div>
      </template>

      <table class="mt-15">
        <tbody>
          <tr
            v-for="(level, levelIndex) in confidenceLevels"
            :key="`level-${levelIndex}`"
          >
            <td class="valign-top min-w-15rem">
              <InsightsUnusualActivityConfidenceBadge
                :confidence-level="confidenceLevelKeyToIndex(level.key)"
                :count="totalInstancesByConfidenceLevels[level.key]"
              />
            </td>
            <td>
              <ul class="pl-0 pb-10">
                <li
                  v-for="(dates, description, index) in reasons[level.key]"
                  :key="`reason-${index}`"
                >
                  {{ description }} on
                  <span
                    v-for="(date, i2) in dates"
                    :key="`date-${i2}`"
                  >
                    <a
                      href="#"
                      @click.prevent="toggleDateDialog(date)"
                    >
                      <span class="z-text-gray-500 no-wrap underline">{{ date | formatDate }}</span>
                    </a>
                    <template v-if="i2 < dates.length - 1">, </template>
                  </span>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>

      <template #footer>
        <div class="d-flex align-items-center small z-text-gray-500 mt-20 gap-5">
          <i class="hi hi-12 hi-info-filled" />
          How rare is this unusual activity?
          <a
            v-track:click="{ label: 'Unusual learn more', location: 'Member view more modal' }"
            rel="noopener noreferrer"
            target="_blank"
            href="https://support.hubstaff.com/hubstaff-insights-unusual-activity"
          >
            Learn more
          </a>
        </div>
      </template>
    </AppDialog>
  </div>
</template>

<script>
import { INSIGHTS_CONFIDENCE_LEVELS } from '~/app_constants';
import InsightsUnusualActivityMemberDialog from '~/components/insights/InsightsUnusualActivityMemberDialog.vue';
import InsightsUnusualActivityConfidenceBadge from '~/components/insights/InsightsUnusualActivityConfidenceBadge.vue';

export default {
  name: 'InsightsUnusualActivityWidgetConfidenceSummary',
  components: {
    InsightsUnusualActivityConfidenceBadge,
    InsightsUnusualActivityMemberDialog,
  },
  props: {
    confidenceSummary: {
      type: [Object, null],
      required: true,
    },
    totalInstancesByConfidenceLevels: {
      type: Object,
      default: () => {},
    },
    currentDashboardUser: {
      type: Object,
      required: true,
    },
    timeZone: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showConfidenceDialog: false,
      showDateDialog: false,
      dialogDate: '',
    };
  },
  computed: {
    confidenceLevels() {
      return [...INSIGHTS_CONFIDENCE_LEVELS].reverse().filter(l => this.reasons[l.key]);
    },
    reasons() {
      return this.confidenceSummary.reasons;
    },
  },
  methods: {
    toggleDateDialog(date) {
      this.showConfidenceDialog = false;
      this.dialogDate = date;
      this.showDateDialog = !this.showDateDialog;

      return false;
    },
    toggleConfidenceDialog() {
      window.analytics?.track('Unusual learn more', { location: 'Single member view' });
      this.showConfidenceDialog = !this.showConfidenceDialog;

      return false;
    },
    confidenceLevelKeyToIndex(key) {
      return INSIGHTS_CONFIDENCE_LEVELS.findIndex(l => l.key === key);
    }
  },
};
</script>
